import { erpApi } from "@/shared/axios";
import { useMutation } from "@tanstack/react-query";
import { urlBackend, urlBackendSoftnet } from '@/shared/constants/networking.constants';

const { post } = erpApi();

const BASE_URL_NOC = `${urlBackend}api/v1/reports/`;

export const useSearchConsultasPorTipoNap = () => {
  return useMutation({
    mutationFn: async (params: any) => {
      const resp = await post<any[]>(
        `${BASE_URL_NOC}consultas-tipo`,
        params,
        true
      );
      return resp;
    },
  });
};

export const useUpdateContratosDetalleFibra = () => {
  return useMutation({
    mutationFn: async (params: any) => {
      const resp = await post<any[]>(
        `${urlBackendSoftnet}/api/liberar-puerto-nap`,
        params,
        true
      );
      return resp;
    },
  });
};